import { useEffect, useState } from 'react';
import { useMutation } from 'data-fetching-client';
import I18n from 'I18n';
import { FavoriteIcon } from 'foundations-assets/icons/components/FavoriteIcon';
import { FavoriteHollowIcon } from 'foundations-assets/icons/components/FavoriteHollowIcon';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import useUpdatePUTableCache from '../hooks/useUpdatePUTableCache';
import { logError } from '../../app/utils/handleError';
import { ADD_FAVORITE, GET_ROLLOUT_PRODUCT_UPDATE_BY_ROLLOUT_ID, GET_ROLLOUT_PRODUCT_UPDATE_BY_UPDATE_ID, REMOVE_FAVORITE } from '../queries';
import { jsx as _jsx } from "react/jsx-runtime";
const FavoriteRolloutIcon = ({
  size,
  rolloutId,
  productUpdateId,
  productUpdateTitle,
  isFavorite: _isFavorite = false,
  isPUHovered,
  alwaysShowIcon = false,
  onAddCompletedCb,
  onRemoveCompletedCb
}) => {
  const {
    updateCache
  } = useUpdatePUTableCache();
  const [isFavorite, setIsFavorite] = useState();
  useEffect(() => {
    setIsFavorite(_isFavorite);
  }, [_isFavorite]);
  const [addFavorite, {
    loading: isAddingFavorite
  }] = useMutation(ADD_FAVORITE, {
    refetchQueries: [{
      query: GET_ROLLOUT_PRODUCT_UPDATE_BY_UPDATE_ID,
      variables: {
        id: productUpdateId
      }
    }, {
      query: GET_ROLLOUT_PRODUCT_UPDATE_BY_ROLLOUT_ID,
      variables: {
        id: rolloutId
      }
    }],
    update: () => {
      updateCache(productUpdateId, {
        isFavorite: true
      });
    },
    onCompleted: () => {
      onAddCompletedCb();
    },
    onError: error => {
      FloatingAlertStore.addAlert({
        message: I18n.text('app.errors.favorites.addFavorite'),
        type: 'danger'
      });
      logError({
        error,
        componentName: 'FavoriteRolloutIcon',
        extra: {
          action: 'add favorite',
          productUpdateId,
          productUpdateTitle
        }
      });
    }
  });
  const [removeFavorite, {
    loading: isRemovingFavorite
  }] = useMutation(REMOVE_FAVORITE, {
    refetchQueries: [{
      query: GET_ROLLOUT_PRODUCT_UPDATE_BY_UPDATE_ID,
      variables: {
        id: productUpdateId
      }
    }, {
      query: GET_ROLLOUT_PRODUCT_UPDATE_BY_ROLLOUT_ID,
      variables: {
        id: rolloutId
      }
    }],
    update: () => {
      updateCache(productUpdateId, {
        isFavorite: false
      });
    },
    onCompleted: () => {
      onRemoveCompletedCb();
    },
    onError: error => {
      FloatingAlertStore.addAlert({
        message: I18n.text('app.errors.favorites.removeFavorite'),
        type: 'danger'
      });
      logError({
        error,
        componentName: 'FavoriteRolloutIcon',
        extra: {
          action: 'remove favorite',
          productUpdateId,
          productUpdateTitle
        }
      });
    }
  });
  const showIcon = alwaysShowIcon || isFavorite || isPUHovered;
  const handleClick = () => {
    if (isAddingFavorite || isRemovingFavorite) {
      return;
    }
    if (isFavorite) {
      setIsFavorite(false);
      void removeFavorite({
        variables: {
          rolloutId
        }
      });
    } else {
      setIsFavorite(true);
      void addFavorite({
        variables: {
          rolloutId
        }
      });
    }
  };
  return /*#__PURE__*/_jsx(IconHolder, {
    cursor: 'pointer',
    size: size,
    icon: isFavorite ? FavoriteIcon : FavoriteHollowIcon,
    color: showIcon ? 'icon-core-default' : 'icon-core-on-fill-default',
    padding: "0",
    onClick: handleClick
  });
};
export default FavoriteRolloutIcon;